export const DDC_PAGE_VIEW = 'ddc.page.view';

function view({
	DDC: {
		dataLayer: {
			page: {
				pageInfo: { pageName: alias }
			}
		}
	}
}) {
	return {
		eventType: DDC_PAGE_VIEW,
		eventData: {
			alias
		}
	};
}

export default view;
